/**
 * Local player identity.
 *
 * v1 is a friends-and-rooms game with no accounts: the browser generates a
 * random player id once and keeps it in localStorage, along with a display
 * name. This id is sent with every backend call and becomes `users.authId`.
 */

const ID_KEY = "domino.playerId";
const NAME_KEY = "domino.displayName";

export function playerId(): string {
  if (typeof localStorage === "undefined") return "local-dev";
  let id = localStorage.getItem(ID_KEY);
  if (!id) {
    id = `p_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
    localStorage.setItem(ID_KEY, id);
  }
  return id;
}

export function displayName(): string {
  if (typeof localStorage === "undefined") return "Player";
  return localStorage.getItem(NAME_KEY) ?? "";
}

export function setDisplayName(name: string): void {
  localStorage.setItem(NAME_KEY, name.trim().slice(0, 24));
}
